
    import "src/shared/components/DynamicInputs/index.module.scss?farm_css_modules";
    
    export default {"dynamicInputs": `dynamicInputs-eddf0e2c`,"inputField": `inputField-eddf0e2c`}
    